module.exports = __webpack_public_path__ + "img/121.83aa895.jpg";